import { RestDefaultHeaders } from '@vivli/core/infrastructure/rest';
import { IRestApiOptions } from '@vivli/core/infrastructure/interface';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';

interface IDefaultApiOptionsProps {
    endpoint: string;
    overrideOptions?: IRestApiOptions;
}

export const useDefaultApiOptions = ({ endpoint, overrideOptions }: IDefaultApiOptionsProps) => {
    const appInsights = useAppInsightsContext();

    if (overrideOptions) {
        return {
            ...overrideOptions,
            endpoint
        };
    }

    return {
        endpoint,
        headers: RestDefaultHeaders,
        retryCalls: '1',
        trackApiCall: (requestTime) => {
            appInsights?.trackEvent({ name: 'React Api Call' }, { endpoint, requestTime });
        }
    };
};
